/** @format */

import Page from 'src/components/Page';
import { Container } from '../../components/container';
import Breadcrumb from 'src/components/Breadcrumb';
import { Button } from 'src/components';
import { Link } from 'react-router-dom';
import { List, ListItem, ListItemText } from '@mui/material';

export default function WidgetPreview() {
  const widgets = [
    {
      title: 'News',
      link: '/widgets-preview/news'
    },
    {
      title: 'Events',
      link: '/widgets-preview/events'
    },
    {
      title: 'Extranet',
      link: '/widgets-preview/extranet'
    },
    {
      title: 'Academy',
      link: '/widgets-preview/academy'
    },
    {
      title: 'Webshop',
      link: '/widgets-preview/webshop'
    }
  ];
  return (
    <Page>
      <Breadcrumb data={[{ title: 'Widgets preview' }]} />
      <Container>
        <div className="ant-dropdown" style={{ position: 'relative', top: 0, left: 0 }}>
          <ul className="ant-dropdown-menu" style={{ boxShadow: 'none' }}>
            {widgets.map(widget => (
              <li className="ant-dropdown-menu-item" key={widget.link} style={{ fontSize: 16 }}>
                <Link to={widget.link}>{widget.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </Page>
  );
}
